import type { ControlMasterDataSource } from '../../../types/network';
import { SOURCE_LABELS, SOURCE_STYLE, isSynced } from './controlMasterDataLabels';

// Small building blocks of the §14a master-data editors (Steuerbox + resources).

export function SourceBadge({ source }: { source?: ControlMasterDataSource | null }) {
  if (!source) return null;
  return (
    <span
      className={`text-[10px] font-medium px-1.5 py-0.5 rounded ${SOURCE_STYLE[source]}`}
      title={isSynced(source) ? `Stammdaten aus ${SOURCE_LABELS[source]} – der tägliche Abgleich hält sie aktuell` : 'Manuell gepflegt – kein Abgleich überschreibt diese Zeile'}
    >
      {SOURCE_LABELS[source]}
    </span>
  );
}

/** Label/value pair of a master-data block; renders nothing without a value. */
export function Fact({ label, value, mono }: { label: string; value?: string | null; mono?: boolean }) {
  if (value == null || value === '') return null;
  return (
    <div className="flex justify-between gap-2 text-[11px]">
      <span className="text-gray-500 dark:text-primary-400 shrink-0">{label}</span>
      <span className={`text-gray-800 dark:text-primary-100 text-right truncate ${mono ? 'font-mono' : ''}`} title={value}>{value}</span>
    </div>
  );
}

/** Notice shown in edit mode of a synced row: editing takes it over into manual care. */
export function TakeoverHint({ source }: { source?: ControlMasterDataSource | null }) {
  if (!isSynced(source)) return null;
  return (
    <div className="text-[11px] text-amber-800 dark:text-amber-200 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded p-2">
      Diese Stammdaten stammen aus {SOURCE_LABELS[source!]}. Eine Änderung übernimmt die Zeile in die manuelle
      Pflege; der tägliche Abgleich aktualisiert sie danach nicht mehr.
    </div>
  );
}

